import { Directive, ElementRef, Injector, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudDataSource, CrudListComponent, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { AMMUNITION_STOCK_EVENT_TYPE, AMMUNITION_STOCK_METADATA, AMMUNITION_STOCK_TYPE, AmmunitionStock, AmmunitionStockEvent, AmmunitionStockEventType, AssetsUser, RANGER_METADATA, RANGER_TYPE, Ranger } from 'assets-model';
import { AmmunitionStockEventDataSource, AmmunitionStockEventService, AmmunitionStockService, RangerService } from 'assets-service';


@Directive()
export abstract class AmmunitionStockEventSearchComponentBase extends CrudListComponent<AmmunitionStockEvent, number> {
  protected systemConfig: any;

  reportRun: any = {};

  displayedColumns: string[] = [ 'ammunitionStockEventId', 'ammunitionStock.ammunitionStockId', 'ranger.rangerId', 'acknowledgeTokenExpires', 'acknowledged', 'ammunitionStockEventType', 'comments', 'createdBy', 'createdDate', 'dateAcknowledged', 'eventDate', 'quantity', 'actions'];

  public searchForm: FormGroup;

  ammunitionStockEventIdFilter: number;
  @ViewChild('ammunitionStockEventIdFilterInput') ammunitionStockEventIdFilterInput: ElementRef;

  ammunitionStockFilter: AmmunitionStock;
  ammunitionStockSelectionList: AmmunitionStock[];
  @ViewChild('ammunitionStockFilterInput') ammunitionStockFilterInput: MatSelect;

  rangerFilter: Ranger;
  rangerSelectionList: Ranger[];
  @ViewChild('rangerFilterInput') rangerFilterInput: MatSelect;

  acknowledgeTokenExpiresFilter: Date;
  @ViewChild('acknowledgeTokenExpiresFilterInput') acknowledgeTokenExpiresFilterInput: ElementRef;
  acknowledgeTokenExpiresLessThanFilter: Date;
  @ViewChild('acknowledgeTokenExpiresLessThanFilterInput') acknowledgeTokenExpiresLessThanFilterInput: ElementRef;
  acknowledgeTokenExpiresLessThanOrEqualToFilter: Date;
  @ViewChild('acknowledgeTokenExpiresLessThanOrEqualToFilterInput') acknowledgeTokenExpiresLessThanOrEqualToFilterInput: ElementRef;
  acknowledgeTokenExpiresGreaterThanFilter: Date;
  @ViewChild('acknowledgeTokenExpiresGreaterThanFilterInput') acknowledgeTokenExpiresGreaterThanFilterInput: ElementRef;
  acknowledgeTokenExpiresGreaterThanOrEqualToFilter: Date;
  @ViewChild('acknowledgeTokenExpiresGreaterThanOrEqualToFilterInput') acknowledgeTokenExpiresGreaterThanOrEqualToFilterInput: ElementRef;

  ammunitionStockEventTypeFilter: AmmunitionStockEventType;
  @ViewChild('ammunitionStockEventTypeFilterInput') ammunitionStockEventTypeFilterInput: ElementRef;

  commentsFilter: string;
  @ViewChild('commentsFilterInput') commentsFilterInput: ElementRef;

  createdByFilter: string;
  @ViewChild('createdByFilterInput') createdByFilterInput: ElementRef;

  createdDateFilter: Date;
  @ViewChild('createdDateFilterInput') createdDateFilterInput: ElementRef;
  createdDateLessThanFilter: Date;
  @ViewChild('createdDateLessThanFilterInput') createdDateLessThanFilterInput: ElementRef;
  createdDateLessThanOrEqualToFilter: Date;
  @ViewChild('createdDateLessThanOrEqualToFilterInput') createdDateLessThanOrEqualToFilterInput: ElementRef;
  createdDateGreaterThanFilter: Date;
  @ViewChild('createdDateGreaterThanFilterInput') createdDateGreaterThanFilterInput: ElementRef;
  createdDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('createdDateGreaterThanOrEqualToFilterInput') createdDateGreaterThanOrEqualToFilterInput: ElementRef;

  dateAcknowledgedFilter: Date;
  @ViewChild('dateAcknowledgedFilterInput') dateAcknowledgedFilterInput: ElementRef;
  dateAcknowledgedLessThanFilter: Date;
  @ViewChild('dateAcknowledgedLessThanFilterInput') dateAcknowledgedLessThanFilterInput: ElementRef;
  dateAcknowledgedLessThanOrEqualToFilter: Date;
  @ViewChild('dateAcknowledgedLessThanOrEqualToFilterInput') dateAcknowledgedLessThanOrEqualToFilterInput: ElementRef;
  dateAcknowledgedGreaterThanFilter: Date;
  @ViewChild('dateAcknowledgedGreaterThanFilterInput') dateAcknowledgedGreaterThanFilterInput: ElementRef;
  dateAcknowledgedGreaterThanOrEqualToFilter: Date;
  @ViewChild('dateAcknowledgedGreaterThanOrEqualToFilterInput') dateAcknowledgedGreaterThanOrEqualToFilterInput: ElementRef;

  eventDateFilter: Date;
  @ViewChild('eventDateFilterInput') eventDateFilterInput: ElementRef;
  eventDateLessThanFilter: Date;
  @ViewChild('eventDateLessThanFilterInput') eventDateLessThanFilterInput: ElementRef;
  eventDateLessThanOrEqualToFilter: Date;
  @ViewChild('eventDateLessThanOrEqualToFilterInput') eventDateLessThanOrEqualToFilterInput: ElementRef;
  eventDateGreaterThanFilter: Date;
  @ViewChild('eventDateGreaterThanFilterInput') eventDateGreaterThanFilterInput: ElementRef;
  eventDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('eventDateGreaterThanOrEqualToFilterInput') eventDateGreaterThanOrEqualToFilterInput: ElementRef;

  quantityFilter: number;
  @ViewChild('quantityFilterInput') quantityFilterInput: ElementRef;
  quantityLessThanFilter: number;
  @ViewChild('quantityLessThanFilterInput') quantityLessThanFilterInput: ElementRef;
  quantityLessThanOrEqualToFilter: number;
  @ViewChild('quantityLessThanOrEqualToFilterInput') quantityLessThanOrEqualToFilterInput: ElementRef;
  quantityGreaterThanFilter: number;
  @ViewChild('quantityGreaterThanFilterInput') quantityGreaterThanFilterInput: ElementRef;
  quantityGreaterThanOrEqualToFilter: number;
  @ViewChild('quantityGreaterThanOrEqualToFilterInput') quantityGreaterThanOrEqualToFilterInput: ElementRef;


  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected ammunitionStockEventService: AmmunitionStockEventService,
    protected ammunitionStockService: AmmunitionStockService,
    protected rangerService: RangerService,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(AMMUNITION_STOCK_EVENT_TYPE, route, router, userStorage, dialog, ammunitionStockEventService, injector);

    this.searchForm = this.fb.group({
      ammunitionStockEventId: [null],
      ammunitionStock: [null],
      ranger: [null],
      acknowledgeTokenExpiresLessThan: [null],
      acknowledgeTokenExpiresLessThanOrEqualTo: [null],
      acknowledgeTokenExpiresGreaterThan: [null],
      acknowledgeTokenExpiresGreaterThanOrEqualTo: [null],
      acknowledgeTokenExpires: [null],
      ammunitionStockEventType: [null],
      comments: [null],
      createdBy: [null],
      createdDateLessThan: [null],
      createdDateLessThanOrEqualTo: [null],
      createdDateGreaterThan: [null],
      createdDateGreaterThanOrEqualTo: [null],
      createdDate: [null],
      dateAcknowledgedLessThan: [null],
      dateAcknowledgedLessThanOrEqualTo: [null],
      dateAcknowledgedGreaterThan: [null],
      dateAcknowledgedGreaterThanOrEqualTo: [null],
      dateAcknowledged: [null],
      eventDateLessThan: [null],
      eventDateLessThanOrEqualTo: [null],
      eventDateGreaterThan: [null],
      eventDateGreaterThanOrEqualTo: [null],
      eventDate: [null],
      quantityLessThan: [null],
      quantityLessThanOrEqualTo: [null],
      quantityGreaterThan: [null],
      quantityGreaterThanOrEqualTo: [null],
      quantity: [null],
      outputFormat: [null],
      download: [null]
    });
  }

  createDataSource(): CrudDataSource<AmmunitionStockEvent> {
    return new AmmunitionStockEventDataSource(this.ammunitionStockEventService);
  }

  createServiceArguments(): any {
    return {
      ammunitionStockEventId: this.ammunitionStockEventIdFilter,
      ammunitionStockId: this.ammunitionStockFilter && this.ammunitionStockFilter.ammunitionStockId,
      rangerId: this.rangerFilter && this.rangerFilter.rangerId,
      acknowledgeTokenExpiresLessThan: this.acknowledgeTokenExpiresLessThanFilter,
      acknowledgeTokenExpiresLessThanOrEqualTo: this.acknowledgeTokenExpiresLessThanOrEqualToFilter,
      acknowledgeTokenExpiresGreaterThan: this.acknowledgeTokenExpiresGreaterThanFilter,
      acknowledgeTokenExpiresGreaterThanOrEqualTo: this.acknowledgeTokenExpiresGreaterThanOrEqualToFilter,
      acknowledgeTokenExpires: this.acknowledgeTokenExpiresFilter,
      ammunitionStockEventType: this.ammunitionStockEventTypeFilter,
      comments: this.commentsFilter,
      createdBy: this.createdByFilter,
      createdDateLessThan: this.createdDateLessThanFilter,
      createdDateLessThanOrEqualTo: this.createdDateLessThanOrEqualToFilter,
      createdDateGreaterThan: this.createdDateGreaterThanFilter,
      createdDateGreaterThanOrEqualTo: this.createdDateGreaterThanOrEqualToFilter,
      createdDate: this.createdDateFilter,
      dateAcknowledgedLessThan: this.dateAcknowledgedLessThanFilter,
      dateAcknowledgedLessThanOrEqualTo: this.dateAcknowledgedLessThanOrEqualToFilter,
      dateAcknowledgedGreaterThan: this.dateAcknowledgedGreaterThanFilter,
      dateAcknowledgedGreaterThanOrEqualTo: this.dateAcknowledgedGreaterThanOrEqualToFilter,
      dateAcknowledged: this.dateAcknowledgedFilter,
      eventDateLessThan: this.eventDateLessThanFilter,
      eventDateLessThanOrEqualTo: this.eventDateLessThanOrEqualToFilter,
      eventDateGreaterThan: this.eventDateGreaterThanFilter,
      eventDateGreaterThanOrEqualTo: this.eventDateGreaterThanOrEqualToFilter,
      eventDate: this.eventDateFilter,
      quantityLessThan: this.quantityLessThanFilter,
      quantityLessThanOrEqualTo: this.quantityLessThanOrEqualToFilter,
      quantityGreaterThan: this.quantityGreaterThanFilter,
      quantityGreaterThanOrEqualTo: this.quantityGreaterThanOrEqualToFilter,
      quantity: this.quantityFilter
    };
  }
  
  clearFiltersBeforeLoadPage() {
    this.restoreFormFromParams(this.searchForm);
  }
  
  clearFilterVariables() {
    this.ammunitionStockEventIdFilter = null;
    this.ammunitionStockFilter = null;
    this.rangerFilter = null;
    this.acknowledgeTokenExpiresLessThanFilter = null;
    this.acknowledgeTokenExpiresLessThanOrEqualToFilter = null;
    this.acknowledgeTokenExpiresGreaterThanFilter = null;
    this.acknowledgeTokenExpiresGreaterThanOrEqualToFilter = null;
    this.acknowledgeTokenExpiresFilter = null;
    this.ammunitionStockEventTypeFilter = null;
    this.commentsFilter = null;
    this.createdByFilter = null;
    this.createdDateLessThanFilter = null;
    this.createdDateLessThanOrEqualToFilter = null;
    this.createdDateGreaterThanFilter = null;
    this.createdDateGreaterThanOrEqualToFilter = null;
    this.createdDateFilter = null;
    this.dateAcknowledgedLessThanFilter = null;
    this.dateAcknowledgedLessThanOrEqualToFilter = null;
    this.dateAcknowledgedGreaterThanFilter = null;
    this.dateAcknowledgedGreaterThanOrEqualToFilter = null;
    this.dateAcknowledgedFilter = null;
    this.eventDateLessThanFilter = null;
    this.eventDateLessThanOrEqualToFilter = null;
    this.eventDateGreaterThanFilter = null;
    this.eventDateGreaterThanOrEqualToFilter = null;
    this.eventDateFilter = null;
    this.quantityLessThanFilter = null;
    this.quantityLessThanOrEqualToFilter = null;
    this.quantityGreaterThanFilter = null;
    this.quantityGreaterThanOrEqualToFilter = null;
    this.quantityFilter = null;
  }
  
  clearFilters() {
    this.clearFilterVariables();
    this.clearFiltersBeforeLoadPage();
    this.loadPage();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.addSearchOnChangedInputEventListener(this.ammunitionStockEventIdFilterInput);
    this.addSearchOnChangedSelectEventListener(this.ammunitionStockFilterInput);
    this.addSearchOnChangedSelectEventListener(this.rangerFilterInput);
    this.addSearchOnChangedInputEventListener(this.acknowledgeTokenExpiresLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.acknowledgeTokenExpiresLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.acknowledgeTokenExpiresGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.acknowledgeTokenExpiresGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.acknowledgeTokenExpiresFilterInput);
    this.addSearchOnChangedInputEventListener(this.ammunitionStockEventTypeFilterInput);
    this.addSearchOnChangedInputEventListener(this.commentsFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdByFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.dateAcknowledgedLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.dateAcknowledgedLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.dateAcknowledgedGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.dateAcknowledgedGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.dateAcknowledgedFilterInput);
    this.addSearchOnChangedInputEventListener(this.eventDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.eventDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.eventDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.eventDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.eventDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.quantityLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.quantityLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.quantityGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.quantityGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.quantityFilterInput);
    this.formStorage.rememberFormChanges(this.searchForm);
  }

  ngOnInit() {
    super.ngOnInit();

    this.ammunitionStockEventService.exportReportSpecification().subscribe(spec => {
      if (!spec) {
        return;
      }
      this.reportRun.outputFormats = spec.outputFormatsSupported;
      this.reportRun.outputFormat = this.reportRun.outputFormats.find(s => s.name == "XLS") || spec.outputFormatsSupported[0];
      this.reportRun.download = !!this.reportRun.outputFormat.downloadOnly;
    });
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }

  protected initExportOptions(config: any): any {
    config = config || {};
      config.export = config.export || {};
      config.export.options = config.export.options || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initExportOptions(config);
  }
  
  protected transformAllPropertiesToModelSetters(): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    const self = this;
    return {
      ammunitionStockEventId: (value: number) => self.ammunitionStockEventIdFilter = value,
      ammunitionStock: (value: AmmunitionStock) => { self.ammunitionStockFilter = value; this.ammunitionStockChanged(value, false); },
      ranger: (value: Ranger) => { self.rangerFilter = value; this.rangerChanged(value, false); },
      acknowledgeTokenExpiresLessThan: (value: Date) => self.acknowledgeTokenExpiresLessThanFilter = value,
      acknowledgeTokenExpiresLessThanOrEqualTo: (value: Date) => self.acknowledgeTokenExpiresLessThanOrEqualToFilter = value,
      acknowledgeTokenExpiresGreaterThan: (value: Date) => self.acknowledgeTokenExpiresGreaterThanFilter = value,
      acknowledgeTokenExpiresGreaterThanOrEqualTo: (value: Date) => self.acknowledgeTokenExpiresGreaterThanOrEqualToFilter = value,
      acknowledgeTokenExpires: (value: Date) => self.acknowledgeTokenExpiresFilter = value,
      ammunitionStockEventType: (value: AmmunitionStockEventType) => self.ammunitionStockEventTypeFilter = value,
      comments: (value: string) => self.commentsFilter = value,
      createdBy: (value: string) => self.createdByFilter = value,
      createdDateLessThan: (value: Date) => self.createdDateLessThanFilter = value,
      createdDateLessThanOrEqualTo: (value: Date) => self.createdDateLessThanOrEqualToFilter = value,
      createdDateGreaterThan: (value: Date) => self.createdDateGreaterThanFilter = value,
      createdDateGreaterThanOrEqualTo: (value: Date) => self.createdDateGreaterThanOrEqualToFilter = value,
      createdDate: (value: Date) => self.createdDateFilter = value,
      dateAcknowledgedLessThan: (value: Date) => self.dateAcknowledgedLessThanFilter = value,
      dateAcknowledgedLessThanOrEqualTo: (value: Date) => self.dateAcknowledgedLessThanOrEqualToFilter = value,
      dateAcknowledgedGreaterThan: (value: Date) => self.dateAcknowledgedGreaterThanFilter = value,
      dateAcknowledgedGreaterThanOrEqualTo: (value: Date) => self.dateAcknowledgedGreaterThanOrEqualToFilter = value,
      dateAcknowledged: (value: Date) => self.dateAcknowledgedFilter = value,
      eventDateLessThan: (value: Date) => self.eventDateLessThanFilter = value,
      eventDateLessThanOrEqualTo: (value: Date) => self.eventDateLessThanOrEqualToFilter = value,
      eventDateGreaterThan: (value: Date) => self.eventDateGreaterThanFilter = value,
      eventDateGreaterThanOrEqualTo: (value: Date) => self.eventDateGreaterThanOrEqualToFilter = value,
      eventDate: (value: Date) => self.eventDateFilter = value,
      quantityLessThan: (value: number) => self.quantityLessThanFilter = value,
      quantityLessThanOrEqualTo: (value: number) => self.quantityLessThanOrEqualToFilter = value,
      quantityGreaterThan: (value: number) => self.quantityGreaterThanFilter = value,
      quantityGreaterThanOrEqualTo: (value: number) => self.quantityGreaterThanOrEqualToFilter = value,
      quantity: (value: number) => self.quantityFilter = value
    }
  }
  
  restoreFormChanges() {
    const self = this;

    // IMPORTANT that the restoreFormChanges call occurs before the initial search - typically best done in onInitAsyncComplete
    // Whereever a form control binds with [ngModel] to a reactive form, ngModel takes precedence,
    // and needs it's own setter function to set the scope attribute bound
    this.formStorage.restoreFormChanges(this.searchForm, this.transformAllPropertiesToModelSetters());
  }
  
  protected getExportConfig(): any {
    if (this.systemConfig && this.systemConfig.export && this.systemConfig.export.options) {
      return this.systemConfig.export.options;
    }
    return {};
  }
  
  protected getMaxExportResults(): number {
    return this.getExportConfig() && this.getExportConfig().maxExportResults;
  }

  isExportEnabled(): boolean {
    return this.reportRun && this.reportRun.download != null && this.reportRun.outputFormat != null
      && this.pageInfo && this.pageInfo.totalElements != null && this.pageInfo.totalElements > 0
      && (this.getMaxExportResults() == null || this.pageInfo.totalElements <= this.getMaxExportResults());
  }

  exportAction() {
    return this.ammunitionStockEventService.exportByFullFiltersAction(this.createServiceArguments(),
      this.reportRun.outputFormat, this.reportRun.download, this.pageSpecification());
  }

  ammunitionStockEventIdChanging(value: number, unsetDependents: boolean = true) {}
  
  ammunitionStockEventIdChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  ammunitionStockLoadSelectionList() {
    this.ammunitionStockService.findAll().subscribe(
      data => {
        this.ammunitionStockSelectionList = data.items;
      }
    );
  }
  
  ammunitionStockDisplay(item: AmmunitionStock) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return AMMUNITION_STOCK_TYPE.description(item);
  }
  
  ammunitionStockChanging(value: AmmunitionStock, unsetDependents: boolean = true) {}
  
  ammunitionStockChanged(value: AmmunitionStock, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }
  
  ammunitionStockCompare(a: any, b: any) {
    return AMMUNITION_STOCK_METADATA.equals(a, b);
  }
  
  

  rangerLoadSelectionList() {
    this.rangerService.findAll().subscribe(
      data => {
        this.rangerSelectionList = data.items;
      }
    );
  }
  
  rangerDisplay(item: Ranger) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return RANGER_TYPE.description(item);
  }
  
  rangerChanging(value: Ranger, unsetDependents: boolean = true) {}
  
  rangerChanged(value: Ranger, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }
  
  rangerCompare(a: any, b: any) {
    return RANGER_METADATA.equals(a, b);
  }
  
  

  acknowledgeTokenExpiresChanging(value: Date, unsetDependents: boolean = true) {}
  
  acknowledgeTokenExpiresChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  acknowledgeTokenExpiresLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  acknowledgeTokenExpiresLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  acknowledgeTokenExpiresLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  acknowledgeTokenExpiresLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  acknowledgeTokenExpiresGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  acknowledgeTokenExpiresGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  acknowledgeTokenExpiresGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  acknowledgeTokenExpiresGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  ammunitionStockEventTypeChanging(value: AmmunitionStockEventType, unsetDependents: boolean = true) {}
  
  ammunitionStockEventTypeChanged(value: AmmunitionStockEventType, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  commentsChanging(value: string, unsetDependents: boolean = true) {}
  
  commentsChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdByChanging(value: string, unsetDependents: boolean = true) {}
  
  createdByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  dateAcknowledgedChanging(value: Date, unsetDependents: boolean = true) {}
  
  dateAcknowledgedChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  dateAcknowledgedLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  dateAcknowledgedLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  dateAcknowledgedLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  dateAcknowledgedLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  dateAcknowledgedGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  dateAcknowledgedGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  dateAcknowledgedGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  dateAcknowledgedGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  eventDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  eventDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  eventDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  eventDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  eventDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  eventDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  eventDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  eventDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  eventDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  eventDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  quantityChanging(value: number, unsetDependents: boolean = true) {}
  
  quantityChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  quantityLessThanChanging(value: number, unsetDependents: boolean = true) {}
  
  quantityLessThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  quantityLessThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  quantityLessThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  quantityGreaterThanChanging(value: number, unsetDependents: boolean = true) {}
  
  quantityGreaterThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  quantityGreaterThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  quantityGreaterThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  disabledTooltip(element) {
    if (!element) {
      return true;
    }
    return element.valid || !element.touched;
  }

  get ammunitionStockEventId() {
    return this.searchForm && this.searchForm.get('ammunitionStockEventId');
  }

  get ammunitionStock() {
    return this.searchForm && this.searchForm.get('ammunitionStock');
  }

  get ranger() {
    return this.searchForm && this.searchForm.get('ranger');
  }

  get acknowledgeTokenExpires() {
    return this.searchForm && this.searchForm.get('acknowledgeTokenExpires');
  }

  get acknowledgeTokenExpiresLessThan() {
    return this.searchForm && this.searchForm.get('acknowledgeTokenExpiresLessThan');
  }
  
  get acknowledgeTokenExpiresLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('acknowledgeTokenExpiresLessThanOrEqualTo');
  }
  
  get acknowledgeTokenExpiresGreaterThan() {
    return this.searchForm && this.searchForm.get('acknowledgeTokenExpiresGreaterThan');
  }
  
  get acknowledgeTokenExpiresGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('acknowledgeTokenExpiresGreaterThanOrEqualTo');
  }

  get ammunitionStockEventType() {
    return this.searchForm && this.searchForm.get('ammunitionStockEventType');
  }

  get comments() {
    return this.searchForm && this.searchForm.get('comments');
  }

  get createdBy() {
    return this.searchForm && this.searchForm.get('createdBy');
  }

  get createdDate() {
    return this.searchForm && this.searchForm.get('createdDate');
  }

  get createdDateLessThan() {
    return this.searchForm && this.searchForm.get('createdDateLessThan');
  }
  
  get createdDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('createdDateLessThanOrEqualTo');
  }
  
  get createdDateGreaterThan() {
    return this.searchForm && this.searchForm.get('createdDateGreaterThan');
  }
  
  get createdDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('createdDateGreaterThanOrEqualTo');
  }

  get dateAcknowledged() {
    return this.searchForm && this.searchForm.get('dateAcknowledged');
  }

  get dateAcknowledgedLessThan() {
    return this.searchForm && this.searchForm.get('dateAcknowledgedLessThan');
  }
  
  get dateAcknowledgedLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('dateAcknowledgedLessThanOrEqualTo');
  }
  
  get dateAcknowledgedGreaterThan() {
    return this.searchForm && this.searchForm.get('dateAcknowledgedGreaterThan');
  }
  
  get dateAcknowledgedGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('dateAcknowledgedGreaterThanOrEqualTo');
  }

  get eventDate() {
    return this.searchForm && this.searchForm.get('eventDate');
  }

  get eventDateLessThan() {
    return this.searchForm && this.searchForm.get('eventDateLessThan');
  }
  
  get eventDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('eventDateLessThanOrEqualTo');
  }
  
  get eventDateGreaterThan() {
    return this.searchForm && this.searchForm.get('eventDateGreaterThan');
  }
  
  get eventDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('eventDateGreaterThanOrEqualTo');
  }

  get quantity() {
    return this.searchForm && this.searchForm.get('quantity');
  }

  get quantityLessThan() {
    return this.searchForm && this.searchForm.get('quantityLessThan');
  }
  
  get quantityLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('quantityLessThanOrEqualTo');
  }
  
  get quantityGreaterThan() {
    return this.searchForm && this.searchForm.get('quantityGreaterThan');
  }
  
  get quantityGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('quantityGreaterThanOrEqualTo');
  }


}



